import api from '@/services/api'
import ProfileEnum from '@/enum/profileEnum'

export default {
  state: {
    isLoggedInSenarRC: !!localStorage.getItem('tokenSenarRC'),
    userRC: {
      codUsuario: '',
      name: '',
      coligada: '',
      filial: '',
      company: '',
      useSeven: '',
      profiles: [],
    },
    companies: [],
  },

  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies
    },

    AUTH(state, user) {
      state.isLoggedInSenarRC = true
      state.userRC = {
        codUsuario: user.codUsuario,
        name: user.name,
        coligada: user.coligada ? user.coligada : '',
        filial: user.filial ? user.filial : '',
        company: user.company ? user.company : '',
        useSeven: user.useSeven ? user.useSeven : '',
        profiles: user.profiles ? user.profiles : [],
      }
    },

    LOGOUT(state) {
      state.isLoggedInSenarRC = false
      state.userRC = {
        codUsuario: '',
        name: '',
        coligada: '',
        filial: '',
        company: '',
        useSeven: '',
        profiles: [],
      }
      state.companies = []
    },
  },

  actions: {
    async auth({ commit }, credentials) {
      try {
        const response = await api.post('/auth', {
          user: credentials.user,
          password: credentials.password,
        })

        const data = response && response.data ? response.data : null

        const token = data && data.token ? data.token : ''
        const user = {
          codUsuario: data && data.user ? data.user.codUsuario : '',
          name: data && data.user ? data.user.name : '',
        }
        const companies = data && data.companies ? data.companies : []

        localStorage.setItem('tokenSenarRC', token)

        commit('AUTH', user)
        commit('SET_COMPANIES', companies)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async setCompany({ commit }, company) {
      try {
        const response = await api.post('/auth/set-company', {
          coligada: company.coligada,
          filial: company.filial,
        })

        const data = response && response.data ? response.data : null

        const token = data && data.token ? data.token : ''
        const user = {
          codUsuario: data && data.user ? data.user.codUsuario : '',
          name: data && data.user ? data.user.name : '',
          coligada: data && data.user ? data.user.coligada : '',
          useSeven: data && data.user ? data.user.useSeven : '',
          filial: data && data.user ? data.user.filial : '',
          company: data && data.user ? data.user.company : '',
          profiles: data && data.user ? data.user.profiles : [],
        }

        localStorage.setItem('tokenSenarRC', token)

        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    logout: ({ commit }) => {
      commit('LOGOUT')
    },
  },

  getters: {
    isLoggedInSenarRC: (state) => state.isLoggedInSenarRC,
    user: (state) => state.userRC,
    isManager: (state) =>
      state.userRC.profiles.find(
        (profile) => profile.id === ProfileEnum.GESTOR,
      ),
    isAssistant: (state) =>
      state.userRC.profiles.find(
        (profile) => profile.id === ProfileEnum.ASSISTENTE,
      ),
    isFinancialManager: (state) =>
      state.userRC.profiles.find(
        (profile) => profile.id === ProfileEnum.GERENTE_FINANCEIRO,
      ),
    isReportGeneral: (state) =>
      state.userRC.profiles.find(
        (profile) => profile.id === ProfileEnum.RELATORIO_GERAL,
      ),
    useSeven: (state) => state.userRC.useSeven === '1',
    companies: (state) => state.companies,
  },
}
